import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import msyLogoGold from "../../images/MSY-Apparel-In-Gold.png";

const Navbar = () => {
  const location = useLocation();
  const { pathname } = location;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const toggleMobileMenu = () => {
    if (isMobileMenuOpen) {
      setIsMobileMenuOpen(false);
      return;
    }
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  const servicePaths = [
    "/hybrid-printing",
    "/embroidery",
    "/heat-transfer",
    "/decals-and-signage",
  ];
  const isServicePage = servicePaths.includes(pathname);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <nav className="bg-black  max-w-screen-2xl mx-auto border-gray-200 dark:border-gray-700">
      <div className="max-w-hybrid-xl flex flex-wrap items-center justify-between mx-auto p-4">
        <Link
          to="/"
          className="flex h-8 items-center space-x-3 rtl:space-x-reverse"
        >
          <img src={msyLogoGold} className="h-12" alt="msy Logo" />
        </Link>
        <button
          onClick={toggleMobileMenu}
          className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden  focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
        >
          <span className="sr-only">Open main menu</span>
          <svg
            className="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 17 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M1 1h15M1 7h15M1 13h15"
            />
          </svg>
        </button>
        <div
          className={`${
            isMobileMenuOpen ? "block w-full" : "hidden"
          }  md:block md:w-auto  `}
          id="navbar-mobile"
        >
          <ul className="flex flex-col font-medium p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-black md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 dark:border-gray-700">
            <li>
              <Link
                to="/"
                className={`${
                  pathname === "/"
                    ? " text-white"
                    : "hover:text-white text-primary"
                }
                block py-2 px-3  rounded md:bg-transparent  md:p-0 `}
                aria-current="page"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className={`${
                  pathname === "/contact"
                    ? " text-white"
                    : "hover:text-white text-primary"
                } block py-2 px-3  rounded  md:hover:bg-transparent md:border-0  md:p-0  `}
              >
                Contact Us
              </Link>
            </li>
            <li>
              <Link
                to="/get-a-quote"
                className={`${
                  pathname === "/get-a-quote"
                    ? " text-white"
                    : "hover:text-white text-primary"
                } block py-2 px-3  rounded  md:hover:bg-transparent md:border-0  md:p-0  `}
              >
                Quote
              </Link>
            </li>
            <li>
              <Link
                to="/about-us"
                className={`${
                  pathname === "/about-us"
                    ? " text-white"
                    : "hover:text-white text-primary"
                } block py-2 px-3  rounded  md:hover:bg-transparent md:border-0  md:p-0  `}
              >
                About Us
              </Link>
            </li>
            <li ref={dropdownRef}>
              <button
                onClick={toggleDropdown}
                className={`${
                  isDropdownOpen || isServicePage
                    ? " text-white"
                    : "hover:text-white text-primary"
                } flex items-center justify-between w-full py-2 px-3 text-primary   md:border-0 hover:text-white md:p-0 md:w-auto   dark:focus:text-white dark:hover:bg-gray-700 md:dark:hover:bg-transparent`}
              >
                Services
                <svg
                  className="w-2.5 h-2.5 ms-2.5"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>
              {isDropdownOpen && (
                <div className={`z-10 relative  md:right-20 md:top-3  `}>
                  <ul
                    className="py-2 text-sm  absolute  font-normal bg-black border-primary border rounded-lg shadow w-44"
                    aria-labelledby="dropdownLargeButton"
                  >
                    <li>
                      <Link
                        to="/hybrid-printing"
                        className={`${
                          pathname === "/hybrid-printing"
                            ? " text-white"
                            : "hover:text-white text-primary"
                        } block py-2 px-3 text-primary rounded   md:border-0 hover:text-white md:mx-auto text-primary `}
                      >
                        Hybrid Printing
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/embroidery"
                        className={`${
                          pathname === "/embroidery"
                            ? " text-white"
                            : "hover:text-white text-primary"
                        } block py-2 px-3 text-primary rounded   md:border-0 hover:text-white md:mx-auto text-primary `}
                      >
                        Embroidery
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/heat-transfer"
                        className={`${
                          pathname === "/heat-transfer"
                            ? " text-white"
                            : "hover:text-white text-primary"
                        } block py-2 px-3 text-primary rounded   md:border-0 hover:text-white md:mx-auto text-primary `}
                      >
                        Heat Transfer
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/decals-and-signage"
                        className={`${
                          pathname === "/decals-and-signage"
                            ? " text-white"
                            : "hover:text-white text-primary"
                        } block py-2 px-3 text-primary rounded   md:border-0 hover:text-white md:mx-auto text-primary `}
                      >
                        Decals & Signage
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
